import { useEffect, useState } from 'react'

// Tailwind's `md` breakpoint — the width at which the messages page switches
// from one-column-at-a-time (list OR thread) to the two-column layout.
const DESKTOP_QUERY = '(min-width: 768px)'

/**
 * True on the two-column (md+) messages layout. Used for behavior that must
 * differ from the CSS-only show/hide: on desktop the page auto-opens the most
 * recent conversation, on mobile it must NOT (there's only one column, so
 * auto-opening would bury the list and silently mark a thread read).
 *
 * Returns false until measured (SSR-safe, and the safer default: no auto-open).
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(DESKTOP_QUERY)
    const sync = () => setIsDesktop(mq.matches)
    sync()
    mq.addEventListener('change', sync)
    return () => mq.removeEventListener('change', sync)
  }, [])

  return isDesktop
}
